import React from 'react';
import palette from '../../color-palette';

interface VeganTagProps {
  background?: string;
  tag?: string;
  className?: string;
}

const VeganTag = ({
  background = palette.background.default,
  tag = palette.secondary.main,
  className,
}: VeganTagProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 2.5 14 10"
    width="25"
    height="25"
    xmlSpace="preserve"
    data-testid="vegan-tag"
    className={className}
    fill={background}
    aria-label="vegan tag"
  >
    <path
      fill={tag}
      d="M10.04,9.72c1.04-0.81,2-2.84,2.18-3.54c0.25-0.98-0.36,0.03-0.54,0.31c-0.25,0.4-0.98,1.54-2.43,2.5
	c-0.57-1.06-0.66-3.4,3.41-4.72C13.88,5.25,14.97,10.02,10.04,9.72"
    />
    <path fill={tag} d="M0.31,4.27h1.19l0.85,3.98h0.02l0.95-3.98h1.13L2.99,9.73H1.65L0.31,4.27z" />
    <path fill={tag} d="M4.96,9.73V4.27h2.98v0.84H6.1v1.35h1.7V7.3H6.1v1.6H8v0.84H4.96z" />
  </svg>
);

export default VeganTag;
